const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  quantityChange: 'quantity-change',
  /** 语种 货币 选择弹窗 */
  languageDialog: 'language-dialog',
};

window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;
